<template>
  <div id="app" style="width: 100%;height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
  }

  input[type=search]::-webkit-search-cancel-button,
  input[type=search]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  html,
  body {
    -webkit-overflow-scrolling: touch;
    height: 100%;
    overflow-x: hidden;
  }

  body {
    line-height: 1;
    font-size: 12px;
  }

  :focus {
    outline: 0
  }

  ol,
  ul {
    list-style: none
  }

  table {
    border-collapse: collapse;
    border-spacing: 0
  }

  img {
    border: 0;
    width: 100%;
    max-width: 100% !important;
    vertical-align: middle;
  }

  input,
  textarea {
    margin: 0;
    padding: 0
  }

  a {
    text-decoration: none;
  }

  a:hover,
  a:focus {
    outline: none;
  }

  q:before,
  q:after {
    content: "";
  }
  html, body, div, span, applet, object, iframe, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, h1, h2, h3, h4, h5, article, section, nav, header, footer {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .page-title{
    font-size: 15px;
    font-weight: bold;
  }

  .table-header th{
    background-color: rgb(245, 247, 250)!important;
  }

  /*滚动条样式*/
  ::-webkit-scrollbar {/*滚动条整体样式*/
    width: 6px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(144,147,153,.3);
    background: rgba(0,0,0,0.2);
  }
  ::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(144,147,153,.3);
    border-radius: 0;
    background: rgba(144,147,153,.3);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue